import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { AddtablesectionComponent } from '../addtablesection/addtablesection.component';
import { TableqrComponent } from '../tableqr/tableqr.component';

@Component({
  selector: 'app-tabledesignview',
  templateUrl: './tabledesignview.component.html',
  styleUrls: ['./tabledesignview.component.css']
})
export class TabledesignviewComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;


  //Edit Get Values
  tableColl: any = [];
  tablesectionBO: any = [];
  tablesectionColl: any = [];
  tablesectionid: number = 0

  tablesectionform = new FormGroup({
    tablesectionid: new FormControl(0),
    tablesectionname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "TableSection";

  isshowqr: boolean = false;

  @Input() tablesectionname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute, public router: Router,
    private productFindService: NgbModal, private loginService: LoginDataService, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.tablesectionid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {

          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnCompanyFaildRedirect();
        }
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
        if (this.loginService.fnCheckUser()) {
          if (this.fnCheckUserPririvilage()) {
            this.isloading = true;
            this.fnOnInitForm();
          }
          else {
            this.fnUserFailedForm();
          }
        }
        else {
          this.loginService.fnGetUserRoleList();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.tablesectionform.reset();
      this.fnInitializeTablesection();

      if (this.tablesectionid > 0) {
        this.fngetTablesection();
      }

      this.fngetTable()


      // console.log(this.loginService.userBO)

      this.isshowqr = this.loginService.userBO.isqrdinein;
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  ngAfterViewInit() {

  }

  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.tablesectionid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeTablesection() {
    this.tablesectionform.setValue({

      tablesectionid: 0,
      tablesectionname: '',
      inactive: false,
    })
  }
  fngetTable() {

    var data = {
      'tablesectionid': this.tablesectionid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTableByTableSection(data)
      .subscribe(
        (res) => {
          this.tableColl = res.json().result;
          let a = 0

          setTimeout(() => {
            for (let abo of this.tableColl) {
              this.registerDragElement(a.toString());
              a = a + 1;
            }
          }, 5000);


          // this.registerDragElement("1");
          // this.registerDragElement("2");
          // this.registerDragElement("3");



        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }
  //Get 
  fngetTablesection() {

    var data = {
      'tablesectionid': this.tablesectionid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getTableSection(data)
      .subscribe(
        (res) => {

          //console.log(res.json())
          this.tablesectionColl = res.json().result;
          var editdata = this.tablesectionColl[0];
          this.tablesectionBO = editdata
          //console.log(this.tablesectionBO)
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {

    try {
      if (this.saveloading) {
        return
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.tablesectionform.valid) {
        this.saveloading = true
        //Check
        var data = {
          'tablesectionid': this.tablesectionid,
          'tablesectionname': this.tablesectionform.get('tablesectionname').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.tablesectionform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }

        this.appService.fnCheckTableSection(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.tablesectionform.get('tablesectionid').value > 0) {
                //Update Department
                this.fnSetTablesection(data);
              }
              else {
                //Insert Department
                this.fnInsertTablesection(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading = false

                this.tablesectionform.controls['tablesectionname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading = false

            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading = false

      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertTablesection(data) {

    this.appService.fnInsertTableSection(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The New Table Section has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.tablesectionid);


        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetTablesection(data) {

    this.appService.fnSetTableSection(data).subscribe(
      (res) => {
        this.saveloading = false

        if (res.json().result != "") {
          this.toastr.success('', "The Table Section has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.tablesectionid, data.tablesection);


        }
      },
      (err) => {
        this.saveloading = false

        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.tablesectionform.setValue({

      tablesectionid: deptBO.tablesectionid,
      tablesectionname: deptBO.tablesectionname,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = true;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


      this.appService.fnInsertActivity(data).subscribe(
        (res) => {
        },
        (err) => {

        });

    } catch {

    }
  }


  fnEditTableSection() {

    try {

      var deptid = this.tablesectionid
      const modalRef = this.productFindService.open(AddtablesectionComponent, { size: <any>'m', backdrop: 'static' });
      modalRef.componentInstance.tablesectionid = deptid;

      modalRef.componentInstance.ngOnInit();
      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

        this.fngetTablesection();

      });

    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  //Close
  fnCloseForm() {
    try {
      this.router.navigate(['/TableSection']);
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }


  fnViewEmenu() {
    if (this.loginService.userBO.emenucode) {
      window.open('https://emenu.expresswala.com/' + this.loginService.userBO.emenucode + '/' + this.tablesectionBO.stablesectionid, "_blank");
    } else {
      this.fnShowErrorMsg('Emenu Code Not Enable');
    }
  }



  fnViewAddonsQr(tableno) {
    if (this.loginService.userBO.qrdineincode) {
      var url = ""
      url = 'https://dinein.poswagon.com/' + this.loginService.userBO.qrdineincode + '/' + tableno;


      const modalRef = this.productFindService.open(TableqrComponent, { size: <any>'m', backdrop: 'static' });
      modalRef.componentInstance.doctype = tableno
      modalRef.componentInstance.url = url;

      modalRef.componentInstance.emitData.subscribe((receivedEntry) => {

      });


    }


  }


  private registerDragElement(id) {
    const elmnt = document.getElementById('mydiv' + id);

    let pos1 = 0,
      pos2 = 0,
      pos3 = 0,
      pos4 = 0;

    const dragMouseDown = (e) => {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    };

    const elementDrag = (e) => {
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:

      // elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
      // elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
     
      elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
      elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';

      //console.log(e);


    };

    const closeDragElement = () => {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    };

    // const elementResize = (e) => {
    //   e = e || window.event;


    //   // set the element's new position:
    //   elmnt.style.height = e.height;
    //   elmnt.style.width = e.width;

    // };



    if (document.getElementById(elmnt.id + 'header')) {
      /* if present, the header is where you move the DIV from:*/
      document.getElementById(elmnt.id + 'header').onmousedown = dragMouseDown;

      // document.getElementById(elmnt.id + 'header').onresize=elementResize;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      elmnt.onmousedown = dragMouseDown;
      // elmnt.onresize = elementResize;
    }
  }



  registerDragElementLoop(a) {

    const elmnt = document.getElementById('mydiv' + a);

    // const elmnt1 = document.getElementById('mydiv' + a + 'header');

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    const dragMouseDown = (e) => {
      alert()
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    };

    const elementDrag = (e) => {
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
      elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
    };

    const closeDragElement = () => {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    };

    console.log(elmnt)
    if (elmnt != null) {

      if (document.getElementById(elmnt.id + 'header')) {

        /* if present, the header is where you move the DIV from:*/
        document.getElementById(elmnt.id + 'header').onmousedown = dragMouseDown;
      } else {

        /* otherwise, move the DIV from anywhere inside the DIV:*/
        elmnt.onmousedown = dragMouseDown;
      }
    }

  }



  registerDragElement41() {

    const elmnt = document.getElementById('mydiv');

    let pos1 = 0, pos2 = 0, pos3 = 0, pos4 = 0;

    const dragMouseDown = (e) => {
      e = e || window.event;
      // get the mouse cursor position at startup:
      pos3 = e.clientX;
      pos4 = e.clientY;
      document.onmouseup = closeDragElement;
      // call a function whenever the cursor moves:
      document.onmousemove = elementDrag;
    };

    const elementDrag = (e) => {
      e = e || window.event;
      // calculate the new cursor position:
      pos1 = pos3 - e.clientX;
      pos2 = pos4 - e.clientY;
      pos3 = e.clientX;
      pos4 = e.clientY;
      // set the element's new position:
      elmnt.style.top = elmnt.offsetTop - pos2 + 'px';
      elmnt.style.left = elmnt.offsetLeft - pos1 + 'px';
    };

    const closeDragElement = () => {
      /* stop moving when mouse button is released:*/
      document.onmouseup = null;
      document.onmousemove = null;
    };

    console.log(elmnt)
    if (document.getElementById(elmnt.id + 'header')) {
      /* if present, the header is where you move the DIV from:*/
      document.getElementById(elmnt.id + 'header').onmousedown = dragMouseDown;
    } else {
      /* otherwise, move the DIV from anywhere inside the DIV:*/
      elmnt.onmousedown = dragMouseDown;
    }
  }

  public allowDrop(ev): void {
    ev.preventDefault();
  }

  public drag(ev): void {
    ev.dataTransfer.setData("text", ev.target.id);
  }

  public drop(ev): void {
    ev.preventDefault();
    var data = ev.dataTransfer.getData("text");
    ev.target.appendChild(document.getElementById(data));
  }

  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }







}



